/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTransactionChannelRequest
 */
export interface UpdateTransactionChannelRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionChannelRequest
     */
    newChannelId: number;
}

/**
 * Check if a given object implements the UpdateTransactionChannelRequest interface.
 */
export function instanceOfUpdateTransactionChannelRequest(value: object): value is UpdateTransactionChannelRequest {
    if (!('newChannelId' in value) || value['newChannelId'] === undefined) return false;
    return true;
}

export function UpdateTransactionChannelRequestFromJSON(json: any): UpdateTransactionChannelRequest {
    return UpdateTransactionChannelRequestFromJSONTyped(json, false);
}

export function UpdateTransactionChannelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTransactionChannelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newChannelId': json['newChannelId'],
    };
}

export function UpdateTransactionChannelRequestToJSON(json: any): UpdateTransactionChannelRequest {
    return UpdateTransactionChannelRequestToJSONTyped(json, false);
}

export function UpdateTransactionChannelRequestToJSONTyped(value?: UpdateTransactionChannelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newChannelId': value['newChannelId'],
    };
}

